import { ICON_TYPES } from '../../common/Elements/Icon/Icon';
import { ACTION_POSITIONS } from '../../common/Elements/Modal/Config';
import useConfirmPopup, {
  useConfirmPopupReturn,
} from '../../common/Elements/Modal/useConfirmPopup';

const useConfirmSaveLegalDocument = (): useConfirmPopupReturn => {
  const [
    ConfirmSaveLegalDocumentModal,
    confirmSaveLegalDocument,
    cancelSaveLegalDocument,
  ] = useConfirmPopup({
    icon: { icon: 'info', iconType: ICON_TYPES.outlined },
    title: 'Publish changes',
    message:
      'Publishing the changes will log out all users and require them to give their consent. Do you want to proceed?',
    confirmBtn: {
      label: 'Publish',
    },
    cancelBtn: false,
    modalId: 'confirm-save-legal-document',
    actionPosition: ACTION_POSITIONS.end,
  });

  return [
    ConfirmSaveLegalDocumentModal,
    confirmSaveLegalDocument,
    cancelSaveLegalDocument,
  ];
};

export default useConfirmSaveLegalDocument;
